<template>
    <form class="row g-3" ref="form">
        <div class="col-12 col-md-6">
            <label for="name" class="form-label fw-bold">{{ $t("gatehouse.name") }}</label>
            <input type="text" class="form-control" id="name" v-model="localGatehouse.name" required>
        </div>
        <div class="col-12 col-md-6">
            <label for="address" class="form-label fw-bold">{{ $t("gatehouse.address") }}</label>
            <input type="text" class="form-control" id="address" v-model="localGatehouse.address" required>
        </div>
    </form>
</template>

<script>
export default {
    emits: ["submit"],
    props: {
        gatehouse: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            localGatehouse: {...this.gatehouse},
        }
    },
    methods: {
        validateData() {
            if (this.$refs.form.checkValidity() === false) {
                this.$refs.form.reportValidity();
                return false;
            }
            return true;
        },
        submitForm() {
            if (!this.validateData()) return;
                this.$emit("submit", this.localGatehouse)
        },
    },
    watch: {
        gatehouse: {
            handler(newVal) {
                this.localGatehouse = {
                    name: newVal.name || "",
                    address: newVal.address || "",
                };
            },
            immediate: true,
        }
    }
}
</script>